export default "__VITE_ASSET__CCJSqvh7__"